var visa_checkout_instance = window.visa_checkout_instance || (function ($) {

    var $def = new $.Deferred();
    var initialized = false;

    return {
		init: function (visaApiDomain, cb) {
            if (!initialized) {
                initialized = true;
				window.onVisaCheckoutReady = function () {
		            $def.resolve();
	            };
                $.getScript(visaApiDomain + '/checkout-widget/resources/js/integration/v1/sdk.js');
            }
            $def.done(function () {
                cb && cb(V);
			});
	        return $def.promise();
        }
    }

})(jQuery);